<div class="form-group mb-1 d-flex justify-content-between align-items-center pt-25">
    <label class="col-form-label p-0" for="">{{ field.label }}</label>
    <div class="custom-control custom-control-primary custom-switch">
        <input type="checkbox" [disabled]="!canEdit" class="custom-control-input" id="chat" [(ngModel)]="_field.value" (change)="onExternalChatChange($event.target.checked)" />
        <label class="custom-control-label" for="chat"></label>
    </div>
</div>